// extracted by mini-css-extract-plugin
module.exports = {"zones":"zones_zones__jXJH3"};